import type { PluginConstructorController, PluginObject } from './types';

import { RefreshLogs } from './plugins/refresh-logs-plugin/refresh-logs';
import { renderRefreshLogsButton } from './plugins/refresh-logs-plugin/render-refresh-logs-button';
import { renderSyncButton } from './plugins/sync-with-db/render-sync-button';
import { SyncWithDb } from './plugins/sync-with-db/sync-with-db';
import { PluginName } from './types';

export const PluginsRecord: Record<PluginName, PluginObject<PluginName, PluginConstructorController[PluginName]>> = {
  [PluginName.RefreshLogs]: {
    renderer: renderRefreshLogsButton,
    pluginController: RefreshLogs,
  },
  [PluginName.SyncWithDb]: {
    renderer: renderSyncButton,
    pluginController: SyncWithDb,
  },
};
